var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrationIconQuickbooksLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 128,
    fill: "#2CA01C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.2 64C68.6 64 56.8 75.8 56.8 90.4v75.2c0 14.6 11.8 26.4 26.4 26.4h8.8V80.8h26.4c14.6 0 26.4 11.8 26.4 26.4s-11.8 26.4-26.4 26.4H108v17.6h10c24.3 0 44-19.7 44-44s-19.7-44-44-44H83.2z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.8 192c14.6 0 26.4-11.8 26.4-26.4V90.4C199.2 75.8 187.4 64 172.8 64H164v111.2h-26.4c-14.6 0-26.4-11.8-26.4-26.4s11.8-26.4 26.4-26.4H148v-17.6h-10c-24.3 0-44 19.7-44 44s19.7 44 44 44h34.8z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationIconQuickbooksLogo);
export default __webpack_public_path__ + "static/media/integration_icon_quickbooks_logo.6e70b562a441e3ea04672b0e20c70b88.svg";
export { ForwardRef as ReactComponent };